<template>
  <path
    d="M18.89 7.70024L12 14.5902L6.41 9.00024H10C10.55 9.00024 11 8.55024 11 8.00024C11 7.45024 10.55 7.00024 10 7.00024H4C3.45 7.00024 3 7.45024 3 8.00024V14.0002C3 14.5502 3.45 15.0002 4 15.0002C4.55 15.0002 5 14.5502 5 14.0002V10.4102L11.29 16.7002C11.68 17.0902 12.31 17.0902 12.7 16.7002L20.29 9.11024C20.68 8.72024 20.68 8.09024 20.29 7.70024C19.91 7.32024 19.27 7.32024 18.89 7.70024Z"
  />
</template>
